import { trustBadges } from "@/mocks/home";

export default function TrustMarquee() {
  const doubled = [...trustBadges, ...trustBadges];
  return (
    <section className="w-full bg-background-950 py-3 md:py-4 overflow-hidden">
      <div className="rv-marquee-track flex items-center gap-16 whitespace-nowrap w-max">
        {doubled.map((b, i) => (
          <div
            key={`${b.label}-${i}`}
            className="flex items-center gap-3 text-background-100/80"
          >
            <i className="ri-shield-check-line text-primary-500 text-lg"></i>
            <span className="font-heading text-sm tracking-[0.28em] font-medium">
              {b.label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}